/**
 * Text Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';

export class TextRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'text';
  }
  
  render(context: ElementRenderContext) {
    let displayText = context.element.content || 'Text eingeben...';
    
    if (context.element.content) {
      displayText = displayText
        .replace(/\{IBAN\}/g, '{IBAN}')
        .replace(/\{SWIFT\/BIC\}/g, '{SWIFT/BIC}')
        .replace(/\{SWIFT\}/g, '{SWIFT}')
        .replace(/\{BIC\}/g, '{BIC}')
        .replace(/\{Bank\}/g, '{Bank}')
        .replace(/\{E-Mail\}/g, '{E-Mail}')
        .replace(/\{Email\}/g, '{Email}')
        .replace(/\{Website\}/g, '{Website}')
        .replace(/\{Amtsgericht\}/g, '{Amtsgericht}')
        .replace(/\{HR-Nr\}/g, '{HR-Nr}')
        .replace(/\{Land\}/g, '{Land}')
        .replace(/\{Steuernummer\}/g, '{Steuernummer}')
        .replace(/\{Ust-IdNr\}/g, '{Ust-IdNr}');
    }
    
    return this.renderEditableText(context, displayText);
  }
}
